// React
import { useEffect, useState } from "react";
// Components
import { BasicButton } from "../../components/menu/common/CommonButton";
// Recoil
import { useRecoilState, useSetRecoilState } from "recoil";
import { isAdminMode, orderState, tableState } from "../../atom/menu";
// Assets
import { TableStateType } from "../../assets/Type";

type NoticeViewPropsTypes = {
  person: TableStateType;
  isView: number;
  setIsView: React.Dispatch<React.SetStateAction<number>>;
};

function PopupNotice(props: NoticeViewPropsTypes) {
  // 매장 공지 화면

  // Recoil State
  const setTableState = useSetRecoilState(tableState);
  const setIsAdminPopup = useSetRecoilState(isAdminMode);
  const [orderData, setOrderData] = useRecoilState(orderState);
  // useState
  const [noticeState, setNoticeState] = useState<boolean>(true);

  // Function
  const tripleClick = () => {
    // **기능정의**
    // 로고 3번 클릭 시, 관리자 페이지 이동 (1초안에 3번 클릭)
    setIsAdminPopup(true);
  };

  useEffect(() => {
    const logoEle = document.getElementById("tripleadmin");
    if (logoEle) {
      // let clicks = 0;
      // let timer,
      //   timeout = 1000;
      logoEle.addEventListener("click", function (e) {
        tripleClick();
        // clicks++;
        // timer = setTimeout(function () {
        //   if (clicks == 3 || clicks == 4) tripleClick();
        //   clicks = 0;
        // }, timeout);
      });
    }
  }, []);

  const nextPage = () => {
    props.setIsView(0);
    if (props.person && orderData) {
      setTableState(props.person);
      setOrderData({ ...orderData, person: props.person });
    }
  };

  return (
    <div className='menu-popup-bg'>
      <div className='menu-popup-wrap'>
        <div className='menu-header-wrap'>
          <img
            id='tripleadmin'
            className='logo-img'
            src={"/assets/images/menu/logo.png"}
            alt='vd company logo'
          />
          {noticeState ? (
            <img
              src={"/assets/images/menu/notice_btn.png"}
              alt='notice button'
              onClick={() => {
                setNoticeState(!noticeState);
              }}
            />
          ) : (
            <img
              src={"/assets/images/menu/notice_btn_active.png"}
              alt='notice button'
              onClick={() => {
                setNoticeState(!noticeState);
              }}
            />
          )}
        </div>
        <div className='menu-intro-wrap' style={{ padding: "0" }}>
          {noticeState ? (
            <div
              className='TO-title-1 text-color-gray-3'
              style={{ textAlign: "center", marginTop: 46 }}
            >
              메뉴를 주문하시기 전에 확인해 주세요
            </div>
          ) : (
            <div
              className='TO-title-1 text-color-gray-3'
              style={{ textAlign: "center", marginTop: 10 }}
            >
              {/* 1992 덮밥&짜글이에서 특별한
              <br />
              이벤트를 진행합니다 */}
            </div>
          )}
          <div className='TO-title-1'></div>
          {noticeState ? (
            <div
              className='TO-body-2 text-color-gray-5'
              style={{ textAlign: "center", marginTop: 70 }}
            >
              1992 덮밥&짜글이는 밑반찬 서비스를 셀프로 운영하고 있습니다.
              <br />
              카운터 옆 매장부스에 밑반찬을 항시 비치하고 있으니 확인하시고
              <br />
              드실만큼만 적당히 담아주세요 😉
              <br />
              <br />
              감사합니다.
            </div>
          ) : (
            <img
              src={"/assets/images/menu/event.jpg"}
              alt='event'
              style={{ width: 1243, marginLeft: 16, marginBottom: 16 }}
            />
          )}
        </div>
        <div className='menu-popup-button' style={{ paddingTop: 0 }}>
          <BasicButton text='주문하기' action={nextPage} />
        </div>
      </div>
    </div>
  );
}
export default PopupNotice;
